import TotalEquipIQLogo from '../icons-logos/TotalEquipIQLogo';
import TotalEquipIQLogoIcon from '../icons-logos/TotalEquipIQLogoIcon';
import TotalEquipIQLogoStacked from '../icons-logos/TotalEquipIQLogoStacked';
import type { CSSProperties, FC } from 'react';

type TEIQspinnerVariant = 'sm' | 'md' | 'lg';
type TEIQspinnerLogoVariant = 'full' | 'icon' | 'stacked';

interface TEIQspinnerProps {
    variant?: TEIQspinnerVariant;
    logoVariant?: TEIQspinnerLogoVariant;
    /** Accessible status label (e.g. "Loading", "Sending…"). */
    label?: string;
    /** When set, text is arranged on an orbiting ring around the logo. */
    orbitText?: string;
    className?: string;
}

const VARIANT_CLASS: Record<TEIQspinnerVariant, string> = {
    sm: 'spinner-sm',
    md: 'spinner-md',
    lg: 'spinner-lg',
};

const LOGO_COMPONENT: Record<TEIQspinnerLogoVariant, FC<{ iconClasses?: string }>> = {
    full: TotalEquipIQLogo,
    icon: TotalEquipIQLogoIcon,
    stacked: TotalEquipIQLogoStacked,
};

const DEFAULT_LABEL = 'Loading';

const TEIQspinner = ({
    variant = 'md',
    logoVariant = 'icon',
    label = DEFAULT_LABEL,
    orbitText,
    className = '',
}: TEIQspinnerProps) => {
    const Logo = LOGO_COMPONENT[logoVariant];
    const orbitChars = orbitText && orbitText.length > 0 ? orbitText.split('') : null;
    const letterCount = orbitChars?.length ?? 0;

    return (
        <div
            className={`spinner ${VARIANT_CLASS[variant]}${orbitChars ? ' spinner-has-orbit' : ''}${className ? ` ${className}` : ''}`}
            role="status"
            aria-label={label}
            style={letterCount > 0 ? ({ '--orbit-letter-count': letterCount } as CSSProperties) : undefined}
        >
            {orbitChars && (
                <div className="spinner-orbit" aria-hidden="true">
                    {orbitChars.map((char, i) => (
                        <span
                            key={`${char}-${i}`}
                            className="spinner-orbit-letter"
                            style={{ '--i': i } as CSSProperties}
                        >
                            {char === ' ' ? '\u00A0' : char}
                        </span>
                    ))}
                </div>
            )}
            <Logo />
        </div>
    );
};

export default TEIQspinner;
